import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TruncatedHtml } from 'site-modules/shared/components/editorial/truncated-html/truncated-html';

const TRUNCATED_SECTION_MIN_HEIGHT = 44;

export const HtmlEntry = memo(props => {
  const { entry } = props;
  return entry.metadata('htmlContent').value() ? (
    <TruncatedHtml entry={entry} expandText="Read more" minHeight={TRUNCATED_SECTION_MIN_HEIGHT} />
  ) : null;
});

HtmlEntry.displayName = 'HtmlEntry';
HtmlEntry.propTypes = {
  entry: PropTypes.shape({
    metadata: PropTypes.func.isRequired,
  }).isRequired,
};
